import {
    differenceInMinutes,
    format,
    isToday,
    isYesterday,
    parseISO,
} from "date-fns";

const TIME_FORMAT = "h:mm a";

export function formatAgentChatTimestamp(
    iso: string,
    now: Date = new Date(),
): string {
    const date = parseISO(iso);
    const diffMin = differenceInMinutes(now, date);

    if (diffMin < 1) {
        return "Just now";
    }
    if (diffMin < 60) {
        return `${diffMin} min ago`;
    }
    if (isToday(date)) {
        return `Today at ${format(date, TIME_FORMAT)}`;
    }
    if (isYesterday(date)) {
        return `Yesterday at ${format(date, TIME_FORMAT)}`;
    }
    if (date.getFullYear() === now.getFullYear()) {
        return `${format(date, "MMM d")} at ${format(date, TIME_FORMAT)}`;
    }
    return `${format(date, "MMM d, yyyy")} at ${format(date, TIME_FORMAT)}`;
}
